var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 94,
    viewBox: "0 0 112 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.3569 70.3649L84.3241 86.618L8.00704 47.7489L16.2619 31.1715",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0582 68.9714L81.0023 84.9261",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5627 67.1911L77.5277 83.1564",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3569 65.5584L74.2614 81.4536",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4453 64.0754L71.3497 79.9706",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5316 62.5914L68.436 78.4866",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6198 61.1084L65.5242 77.0036",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2899 59.9218L63.1943 75.817",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9581 58.7343L60.8626 74.6294",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9485 56.9148L57.6589 72.9977",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6476 55.2335L54.4202 71.3875",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2612 53.2902L50.9453 69.6179",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0743 51.6211L47.7558 67.954",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1606 50.1371L44.8421 66.4701",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2488 48.6541L41.9303 64.987",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3351 47.1702L39.0166 63.5031",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0052 45.9835L36.6867 62.3164",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6753 44.7969L34.3568 61.1298",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5433 43.0288L31.1514 59.4972",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4159 41.436L27.9476 57.8655",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9191 39.4604L24.4519 56.0851",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7152 37.8286L21.2481 54.4533",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8033 36.3456L18.3362 52.9703",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8898 34.8617L15.4227 51.4864",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0416 33.3869L12.5109 50.0033",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6462 32.1911L10.1791 48.8158",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4556 39.8574L89.3002 35.7038",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8929 37.0179L92.7162 34.8907",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2861 68.9023L33.2551 64.3027",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5877 69.5865C34.0277 66.7985 34.0277 66.7985 34.0277 66.7985",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0307 68.4458L90.0704 69.4847L85.3241 78.8036L83.2844 77.7648L88.0307 68.4458Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3075 40.8715L37.3472 41.9103L32.6054 51.2206L30.5657 50.1818L35.3075 40.8715Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8493 35.6759L27.889 36.7147L23.1428 46.0337L21.103 44.9948L25.8493 35.6759Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6938 31.5223L19.7335 32.5611L14.9873 41.88L12.9476 40.8412L17.6938 31.5223Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2888 59.344L72.3285 60.3828L67.7035 69.4638L65.6638 68.425L70.2888 59.344Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6725 54.656L63.7105 55.694L58.9643 65.0129L56.9263 63.9749L61.6725 54.656Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0594 49.7599L54.0991 50.7988L49.3529 60.1177L47.3132 59.0789L52.0594 49.7599Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0526 45.3146L46.0906 46.3525L41.3443 55.6715L39.3064 54.6335L44.0526 45.3146Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4191 63.5506L80.4571 64.5886L75.7109 73.9075L73.6729 72.8695L78.4191 63.5506Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95212 45.3613C4.59445 43.4645 4.33081 40.8889 5.49445 38.6815L21.0214 9.23479C22.6572 6.13469 26.4912 4.93948 29.5991 6.56175L103.585 45.1997C106.679 46.8149 107.896 50.6216 106.312 53.7308L91.5923 82.6326C90.7112 84.3626 89.1481 85.5156 87.3985 85.9349L95.0475 71.3633L15.2262 30.3442L13.9391 29.7696L5.95212 45.3613Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3984 85.9349L84.3242 86.618",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95216 45.3614L8.00726 47.749",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4045 48.6257L44.418 36.4091C44.418 36.4091 40.4295 35.8456 40.4027 39.4983L68.46 53.7881C68.46 53.7881 70.7183 52.0048 68.4045 48.6257Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0668 65.2804L92.8162 63.6248L91.0762 66.7747L94.4346 68.4851L96.0668 65.2804Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6015 56.8945L76.3508 55.2389L74.6109 58.3888L77.9693 60.0992L79.6015 56.8945Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M87.757 61.0481L84.5063 59.3925L82.7663 62.5424L86.1247 64.2528L87.757 61.0481Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1964 29.6152L24.9457 27.9596L23.2067 31.1077L26.5651 32.8182L28.1964 29.6152Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9151 25.9067L17.6644 24.2511L15.9254 27.3992L19.2838 29.1097L20.9151 25.9067Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7697 33.4724L32.519 31.8168L30.7799 34.9649L34.1383 36.6754L35.7697 33.4724Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7636 33.1203C66.1198 32.7923 65.7638 32.2007 65.9685 31.7987C66.1732 31.3968 66.8611 31.3367 67.505 31.6647C68.1488 31.9926 68.5048 32.5843 68.3001 32.9862C68.0954 33.3882 67.4075 33.4482 66.7636 33.1203Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1661 42.1474C61.5222 41.8194 61.1663 41.2278 61.371 40.8258C61.5757 40.4239 62.2636 40.3638 62.9074 40.6918C63.5513 41.0197 63.9073 41.6114 63.7026 42.0133C63.4978 42.4153 62.8099 42.4753 62.1661 42.1474Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5397 37.4871C63.8958 37.1592 63.5398 36.5675 63.7446 36.1655C63.9493 35.7636 64.6372 35.7036 65.281 36.0315C65.9249 36.3594 66.2809 36.9511 66.0762 37.353C65.8714 37.755 65.1835 37.815 64.5397 37.4871Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4446 20.3667C41.8008 20.0388 41.4448 19.4471 41.6495 19.0452C41.8542 18.6432 42.5421 18.5832 43.186 18.9111C43.8298 19.2391 44.1858 19.8307 43.9811 20.2327C43.7764 20.6346 43.0885 20.6947 42.4446 20.3667Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8469 29.3939C37.203 29.066 36.8471 28.4743 37.0518 28.0723C37.2565 27.6704 37.9444 27.6104 38.5882 27.9383C39.2321 28.2662 39.5881 28.8579 39.3834 29.2598C39.1786 29.6618 38.4907 29.7218 37.8469 29.3939Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2196 24.7353C39.5757 24.4074 39.2197 23.8157 39.4245 23.4138C39.6292 23.0118 40.3171 22.9518 40.9609 23.2797C41.6048 23.6076 41.9608 24.1993 41.756 24.6013C41.5513 25.0032 40.8634 25.0632 40.2196 24.7353Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5415 15.323C31.8976 14.9951 31.5416 14.4034 31.7464 14.0014C31.9511 13.5995 32.639 13.5395 33.2828 13.8674C33.9267 14.1953 34.2827 14.787 34.0779 15.1889C33.8732 15.5909 33.1853 15.6509 32.5415 15.323Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9437 24.3501C27.2998 24.0222 26.9439 23.4305 27.1486 23.0286C27.3533 22.6266 28.0412 22.5666 28.685 22.8945C29.3289 23.2225 29.6849 23.8141 29.4802 24.2161C29.2754 24.618 28.5875 24.6781 27.9437 24.3501Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3164 19.6916C29.6726 19.3636 29.3166 18.772 29.5213 18.37C29.726 17.9681 30.4139 17.908 31.0578 18.236C31.7016 18.5639 32.0576 19.1556 31.8529 19.5575C31.6482 19.9595 30.9603 20.0195 30.3164 19.6916Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3703 25.5639C52.7265 25.236 52.3705 24.6443 52.5752 24.2424C52.7799 23.8404 53.4678 23.7804 54.1117 24.1083C54.7555 24.4363 55.1115 25.0279 54.9068 25.4299C54.7021 25.8318 54.0142 25.8918 53.3703 25.5639Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7717 34.5927C48.1278 34.2648 47.7718 33.6731 47.9766 33.2711C48.1813 32.8692 48.8692 32.8092 49.513 33.1371C50.1569 33.465 50.5129 34.0567 50.3082 34.4586C50.1034 34.8606 49.4155 34.9206 48.7717 34.5927Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1453 29.9323C50.5014 29.6044 50.1454 29.0127 50.3502 28.6108C50.5549 28.2088 51.2428 28.1488 51.8866 28.4767C52.5305 28.8047 52.8865 29.3963 52.6818 29.7983C52.477 30.2002 51.7891 30.2603 51.1453 29.9323Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4045 48.6257L66.3282 52.7024",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3933 48.1107L65.317 52.1874",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5073 47.6594L64.431 51.7361",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5256 47.1594L63.4493 51.2361",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5581 50.7823L64.6344 46.7056",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7449 46.2524L61.6686 50.3291",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7319 45.7366L60.6556 49.8133",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8459 45.2853L59.7696 49.362",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M60.866 44.7863L58.7897 48.863",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8967 48.4081L59.973 44.3314",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0833 43.8783L57.007 47.955",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0721 43.3633L55.9958 47.44",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M57.186 42.9121L55.1097 46.9888",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2045 42.412L54.1282 46.4888",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2369 46.0349L55.3132 41.9582",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4237 41.5051L52.3474 45.5818",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4107 40.9892L51.3344 45.0659",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5247 40.5379L50.4484 44.6146",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5447 40.0388L49.4684 44.1155",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5755 43.6608L50.6518 39.584",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7623 39.131L47.686 43.2077",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7511 38.616L46.6748 42.6927",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8651 38.1647L45.7887 42.2414",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8833 37.6648L44.807 41.7415",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9157 41.2875L45.992 37.2108",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0516 40.338L44.0536 36.4072",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0262 40.8345L45.1025 36.7578",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1853 43.1948L75.6203 45.0775L73.9717 47.0599L95.6337 58.0925L96.3874 55.6545L97.1511 53.1799L97.8816 50.8131L98.6676 48.269L80.6143 39.0742L78.8936 41.1423L77.187 43.1957",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8817 50.813L78.8937 41.1422",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1511 53.1798L77.1871 43.1957L77.1853 43.1948",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M96.386 55.6535L75.6206 45.0775",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.00235f2fbc7c7bfb27db7c910009c352.svg";
export { ForwardRef as ReactComponent };